import { CARD_TYPES } from './constants'

const compareByType = (a, b) => {
    if (a.type === CARD_TYPES.ANNOUNCEMENTS) {
        if (b.type === CARD_TYPES.NEWS) {
            return -1
        }

        return b.position - a.position
    }

    if (b.type === CARD_TYPES.ANNOUNCEMENTS) {
        return 1
    }

    return b.publication_start - a.publication_start
}

/**
 * sort announcements and news mixed array:
 * first unread announcements ordered by date
 * then unread news ordered by publication date
 * then read announcements ordered by date
 * then read news ordered by publication date
 */
export const sortAnnouncementCards = (items, announcementsStatus) => {
    return [...items].sort((a, b) => {
        if (announcementsStatus.isRead(a)) {
            if (announcementsStatus.isRead(b)) {
                return compareByType(a, b)
            }

            return 1
        }

        if (announcementsStatus.isRead(b)) {
            return -1
        }

        return compareByType(a, b)
    })
}



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/AnnouncementsCard/helpers.js